import { h } from "@stencil/core";
import { ColumnTypes, InternalColumnTypes } from "./column-types";

interface SchemaItem {
    labels?: {
        column?: string;
        update?: string;
        active?: string;
        inactive?: string;
    };
    type?: ColumnTypes | InternalColumnTypes;
    dateKey?: string;
    sortable?: boolean;
    "primary-mobile"?: boolean;
    hidden?: boolean;
}

interface TableHeaderProps {
    schema: { [key: string]: SchemaItem };
    sortedKeys: string[];
    handleSort: (key: string) => void;
    translate: (key: string) => string;
}

export const TableHeader = ({
    schema,
    sortedKeys,
    handleSort,
    translate,
}: TableHeaderProps) => {
    const headers = sortedKeys.map((key) => ({ key, item: schema[key] }));

    return (
        <thead>
            <tr>
                {headers.map(({ key, item }) => {
                    if (item?.type === "hidden") {
                        return null;
                    }
                    const translateKey = `${key}.column`;
                    const translatedValue = translate(translateKey);
                    const label =
                        typeof item?.labels?.column !== "undefined"
                            ? item?.labels?.column
                            : translatedValue !== translateKey
                            ? translatedValue
                            : key;
                    return item?.sortable ? (
                        <th key={key} data-testid={key}>
                            <ux-table-sort
                                ascName="asc"
                                descName="desc"
                                onClick={() => handleSort(key)}
                            >
                                <span
                                    class={{
                                        "ux-iws-table-header--text-and-date":
                                            item.type ===
                                            InternalColumnTypes.TextAndDate,
                                        "ux-iws-sateful-table__header--long-label":
                                            label.length > 30,
                                    }}
                                >
                                    {label}
                                </span>
                            </ux-table-sort>
                        </th>
                    ) : (
                        <th>{label}</th>
                    );
                })}
            </tr>
        </thead>
    );
};
